// Function to show or hide the popup based on localStorage
function showLocationPopup() {
  if(Shopify.country != 'US'){
  // Check if the popup was closed in the last 7 days
  const lastClosed = localStorage.getItem('location_popup_closed');
  const now = new Date();

  if (lastClosed && (now - new Date(lastClosed)) / (1000 * 60 * 60 * 24) < 7) {
    // If the popup was closed less than 7 days ago, don't show it
    document.querySelector('.location_popup').style.display = 'none';
  } else {
    // If not, show the popup
    document.querySelector('.location_popup').style.display = 'block';
  }
  }
}

// Function to close the popup and save the close time in localStorage
function closeLocationPopup() {
  document.querySelector('.location_popup').style.display = 'none';
  localStorage.setItem('location_popup_closed', new Date().toISOString());
}

// Function to update the helper text based on the user's country
function updateHelperText() {
  const helperTextElement = document.querySelector('.location_popup_text');
  console.log(Shopify.country);
  if (helperTextElement) {
     switch (Shopify.country) {
        case 'CA':  // Canada
            helperTextElement.innerText = 'FREE international shipping with a minimum order of $99.';
            break;
        case 'UK':  // United Kingdom
            helperTextElement.innerText = 'FREE international shipping with a minimum order of $99.';
            break;
        case 'AU':  // Australia
            helperTextElement.innerText = 'FREE international shipping with a minimum order of $99.';
            break;
        case 'DE':  // Germany
            helperTextElement.innerText = 'KOSTENLOSER internationaler Versand bei einem Mindestbestellwert von 99 $.';
            break;
        case 'MX':  // Mexico
            helperTextElement.innerText = 'ENVÍO internacional GRATIS con un pedido mínimo de $99.';
            break;
        case 'SA':  // Saudi Arabia
            helperTextElement.innerText = 'الشحن الدولي المجاني للطلبات التي تزيد عن 99 دولارًا.';
            break;
        case 'IE':  // Ireland
            helperTextElement.innerText = 'FREE international shipping with a minimum order of $99.';
            break;
        case 'FR':  // France
            helperTextElement.innerText = 'LIVRAISON internationale GRATUITE pour toute commande d\'au moins 99 $.';
            break;
        case 'ZA':  // South Africa
            helperTextElement.innerText = 'FREE international shipping with a minimum order of $99.';
            break;
        case 'IN':  // India
            helperTextElement.innerText = 'मुफ्त अंतरराष्ट्रीय शिपिंग $99 के न्यूनतम ऑर्डर पर।';
            break;
        case 'SG':  // Singapore
            helperTextElement.innerText = 'FREE international shipping with a minimum order of $99.';
            break;
        case 'IT':  // Italy
            helperTextElement.innerText = 'SPEDIZIONE internazionale GRATUITA con un ordine minimo di 99 $.';
            break;
        case 'ES':  // Spain
            helperTextElement.innerText = 'ENVÍO internacional GRATIS con un pedido mínimo de 99 $.';
            break;
        case 'BR':  // Brazil
            helperTextElement.innerText = 'FRETE internacional GRÁTIS com um pedido mínimo de $99.';
            break;
        case 'NL':  // Netherlands
            helperTextElement.innerText = 'GRATIS internationale verzending bij een minimale bestelling van 99 $.';
            break;
        case 'SE':  // Sweden
            helperTextElement.innerText = 'GRATIS internationell frakt vid en minimibeställning på 99 $.';
            break;
        case 'NZ':  // New Zealand
            helperTextElement.innerText = 'FREE international shipping with a minimum order of $99.';
            break;
        case 'IL':  // Israel
            helperTextElement.innerText = 'משלוח בינלאומי חינם בהזמנה מינימלית של 99 $.';
            break;
        case 'AE':  // United Arab Emirates
            helperTextElement.innerText = 'شحن دولي مجاني مع حد أدنى للطلب يبلغ 99 دولارًا.';
            break;
        case 'PR':  // Puerto Rico
            helperTextElement.innerText = 'ENVÍO internacional GRATIS con un pedido mínimo de 99 $.';
            break;
        case 'GR':  // Greece
            helperTextElement.innerText = 'ΔΩΡΕΑΝ διεθνής αποστολή με ελάχιστη παραγγελία 99 $.';
            break;
        case 'AR':  // Argentina
            helperTextElement.innerText = 'ENVÍO internacional GRATIS con un pedido mínimo de $99.';
            break;
        case 'RO':  // Romania
            helperTextElement.innerText = 'LIVRARE internațională GRATUITĂ pentru comenzi de minim 99 $.';
            break;
        case 'CO':  // Colombia
            helperTextElement.innerText = 'ENVÍO internacional GRATIS con un pedido mínimo de 99 $.';
            break;
        case 'ID':  // Indonesia
            helperTextElement.innerText = 'PENGIRIMAN internasional GRATIS dengan pesanan minimal $99.';
            break;
        case 'PT':  // Portugal
            helperTextElement.innerText = 'ENVIO internacional GRÁTIS para pedidos de no mínimo $99.';
            break;
        case 'CH':  // Switzerland
            helperTextElement.innerText = 'LIVRAISON internationale GRATUITE pour toute commande d\'au moins 99 $.';
            break;
        case 'PL':  // Poland
            helperTextElement.innerText = 'DARMOWA wysyłka międzynarodowa przy minimalnym zamówieniu 99 $.';
            break;
        case 'EG':  // Egypt
            helperTextElement.innerText = 'شحن دولي مجاني للطلبات التي لا تقل عن 99 دولارًا.';
            break;
      // Add other country cases here as needed
      default:
        helperTextElement.innerText = 'FREE International Shipping with a minimum purchase of $99.';
    }
  }
}

// Event listener for closing the popup
document.querySelector('#close_location_popup').addEventListener('click', closeLocationPopup);

// Run the update and show popup on page load
document.addEventListener('DOMContentLoaded', function() {
  updateHelperText();
  showLocationPopup();
});
